"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidEdgeTypeFnFactory = exports.InvalidatedReason = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const debug = datamodel_core_1.DEBUG_OVERRIDE || (datamodel_core_1.NOT_LAMBDA && false);
var InvalidatedReason;
(function (InvalidatedReason) {
    InvalidatedReason["BAD_EDGE_TYPE_ID"] = "BAD_EDGE_TYPE_ID";
    InvalidatedReason["INVALID_TYPES"] = "INVALID_TYPES";
    InvalidatedReason["MISSING_CLASS_USER_ATT"] = "MISSING_CLASS_USER_ATT";
    InvalidatedReason["MISSING_EDGE_TYPE_ID"] = "MISSING_EDGE_TYPE_ID";
})(InvalidatedReason || (exports.InvalidatedReason = InvalidatedReason = {}));
/** returns a function based on provided edgeTypeMatrix and businessObjectAssember which when called with source, target and edgeTypeIds returns whether combination is valid for this datamodel configuration */
const isValidEdgeTypeFnFactory = ({ edgeTypeMatrix, businessObjectAssembler }) => {
    return ({ sourceObjectTypeId, targetObjectTypeId: targetObjectTypeId, edgeTypeId }) => {
        const getResolvedEdgeTypeId = (itemType, parentType) => {
            const overrides = {
                Customer: {
                    Customer: edgeTypeMatrix.Customer?.Customer?.customer_has_subCustomer_typeZ?.edgeTypeId,
                    Device: edgeTypeMatrix.Customer?.Device?.customer_has_been_allocated_device.edgeTypeId,
                },
            };
            return overrides[parentType]?.[itemType] ?? (0, datamodel_core_1.getParentEdgeTypeId)(targetObjectTypeId, sourceObjectTypeId);
        };
        const untypeEdgeTypeMatrix = edgeTypeMatrix;
        const res = { isValid: false, reason: undefined };
        const edgeTypeDefintionMap = untypeEdgeTypeMatrix[sourceObjectTypeId]?.[targetObjectTypeId];
        if (edgeTypeDefintionMap) {
            if (edgeTypeId) {
                /** this absolutely requires the contraint that each entry key must equal the edgeTypeId attribute of the entry */
                res.isValid = !!edgeTypeDefintionMap[edgeTypeId];
                if (!res.isValid) {
                    res.reason = InvalidatedReason.BAD_EDGE_TYPE_ID;
                    res.resolvedEdgeTypeId = getResolvedEdgeTypeId(targetObjectTypeId, sourceObjectTypeId);
                    res.violation = edgeTypeId;
                }
            }
            else {
                res.reason = InvalidatedReason.MISSING_EDGE_TYPE_ID;
                res.isValid = false;
                res.resolvedEdgeTypeId = getResolvedEdgeTypeId(targetObjectTypeId, sourceObjectTypeId);
                res.violation = edgeTypeId;
            }
            if (!res.isValid) {
                debug &&
                    console.log(`${res.reason} between ${sourceObjectTypeId} and ${targetObjectTypeId} from edgeTypeMatix: ${res.violation}, ${res.resolvedEdgeTypeId ? `proposed: ${res.resolvedEdgeTypeId}` : ''}`);
            }
        }
        else {
            /** userAttribute.name is very legacy and needs to be removed from all class defined links */
            /** get legacy definition from source and target classes */
            try {
                const sourceInstance = businessObjectAssembler.getInstanceFromPrimaryKey(`${sourceObjectTypeId}:`);
                const userAttributes = sourceInstance?.getUserAttributes();
                const parentDefinedUserAttDefs = Object.values(userAttributes).find((userAttributeDef) => (userAttributeDef?.objectTypeId ?? userAttributeDef?.name) === targetObjectTypeId && userAttributeDef?.direction === datamodel_core_1.PathDirection.child);
                const childDefinedUserAttDefs = Object.values(userAttributes).find((userAttributeDef) => (userAttributeDef?.objectTypeId ?? userAttributeDef?.name) === sourceObjectTypeId && userAttributeDef?.direction === datamodel_core_1.PathDirection.parent);
                if (parentDefinedUserAttDefs || childDefinedUserAttDefs) {
                    res.isValid = true;
                }
                else {
                    res.isValid = false;
                    res.reason = InvalidatedReason.INVALID_TYPES;
                }
            }
            catch (e) {
                // expect errors where class requires certain constructor props
                // to reach here it is likely the edgeTypeMatrix is missing the defintion!
                const { message } = e;
                (res.isValid = false), (res.reason = message);
            }
        }
        return res;
    };
};
exports.isValidEdgeTypeFnFactory = isValidEdgeTypeFnFactory;
